import React from 'react';
import autobind from 'autobind-decorator';
import Base from 'client/components/base';
import StringStore from 'client/stores/strings';
import Button from 'client/components/common/button-rounded';
import baseUrl from 'server/routes/base-url';

export default class HomeHero extends Base {
  constructor(props) {
    super(props);
    this.state = {
      css: {
        height: '0px',
      },
    };

    this.onResize = this.onResize.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  onResize() {
    return;
    this.setState({
      css: {
        height: window.innerHeight - 94 + 'px',
      },
    });
  }

  @autobind
  onGetApp() {
    let element = document.getElementById('getapp');
    if (element) {
      element.scrollIntoView();
    }
  }

  render() {
    return (
      <section className={this.css()} style={this.state.css}>
        <div className="content">
          <div className="body">
            <h1>{StringStore.get('home.hero.title')}</h1>
            {StringStore.get('home.hero.body')}
            <Button onClick={this.onGetApp} variant="button-rounded-yellow">
              {StringStore.get('home.hero.getApp')}
            </Button>
            <Button linkTo={`${baseUrl}discover`}>
              {StringStore.get('home.hero.listen')}
            </Button>
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./client/components/landing/hero/hero.es6